module.exports = __webpack_public_path__ + "img/great.d1d2e3fe.gif";